// OneTrust standard category ids (must match the ids classic renders via tOneTrust.php)
export const ONETRUST_CATEGORY = {
  PERFORMANCE: 'C0002',
  TARGETING: 'C0004',
  SOCIAL_MEDIA: 'C0008',
};

// Map an analytics platform to its OneTrust category, mirroring classic
export function getPlatformCategory(platform, isExtended) {
  // Classic renders the internal ShowClix GA with SCRIPT_PERFORMANCE (ga-showclix.tpl.php)
  if (platform === 'google-analytics-sc') {
    return ONETRUST_CATEGORY.PERFORMANCE;
  }
  if (isExtended && platform === 'facebook') {
    return ONETRUST_CATEGORY.SOCIAL_MEDIA;
  }
  return ONETRUST_CATEGORY.TARGETING;
}

function getActiveGroups() {
  const groups = window.OnetrustActiveGroups || window.OptanonActiveGroups;
  if (typeof groups !== 'string' || groups.length === 0) {
    return null;
  }
  return groups;
}

export function isOneTrustPresent() {
  return getActiveGroups() !== null;
}

export function isCategoryConsented(categoryId) {
  const groups = getActiveGroups();
  if (groups === null) {
    return null;
  }
  return groups.indexOf(',' + categoryId + ',') !== -1;
}

export function isPlatformAllowed(platform, isExtended) {
  const consented = isCategoryConsented(getPlatformCategory(platform, isExtended));
  return consented === null ? true : consented;
}

export function filterAnalyticsByConsent(analytics, isExtended) {
  const next = {};
  Object.keys(analytics || {}).forEach((platform) => {
    if (isPlatformAllowed(platform, isExtended)) {
      next[platform] = analytics[platform];
    }
  });
  return next;
}

export function resolveMarketingDisabled() {
  const consented = isCategoryConsented(ONETRUST_CATEGORY.TARGETING);
  return consented === null ? false : !consented;
}

export function shouldDeferForOneTrust(oneTrustEnabled) {
  return !!oneTrustEnabled && !isOneTrustPresent();
}

// Poll until the async OneTrust SDK populates consent, then run the callback once.
export function whenOneTrustReady(callback, { interval = 100, timeout = 10000 } = {}) {
  if (isOneTrustPresent()) {
    callback();
    return () => {};
  }
  const start = Date.now();
  const id = setInterval(() => {
    if (isOneTrustPresent()) {
      clearInterval(id);
      callback();
    } else if (Date.now() - start >= timeout) {
      clearInterval(id);
    }
  }, interval);
  return () => clearInterval(id);
}
